/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PopupConfigInfoRespVo } from './PopupConfigInfoRespVo';
import {
    PopupConfigInfoRespVoFromJSON,
    PopupConfigInfoRespVoFromJSONTyped,
    PopupConfigInfoRespVoToJSON,
    PopupConfigInfoRespVoToJSONTyped,
} from './PopupConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseListPopupConfigInfoRespVo
 */
export interface ResponseListPopupConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListPopupConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListPopupConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<PopupConfigInfoRespVo>}
     * @memberof ResponseListPopupConfigInfoRespVo
     */
    data?: Array<PopupConfigInfoRespVo>;
}

/**
 * Check if a given object implements the ResponseListPopupConfigInfoRespVo interface.
 */
export function instanceOfResponseListPopupConfigInfoRespVo(value: object): value is ResponseListPopupConfigInfoRespVo {
    return true;
}

export function ResponseListPopupConfigInfoRespVoFromJSON(json: any): ResponseListPopupConfigInfoRespVo {
    return ResponseListPopupConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponseListPopupConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListPopupConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PopupConfigInfoRespVoFromJSON)),
    };
}

export function ResponseListPopupConfigInfoRespVoToJSON(json: any): ResponseListPopupConfigInfoRespVo {
    return ResponseListPopupConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponseListPopupConfigInfoRespVoToJSONTyped(value?: ResponseListPopupConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PopupConfigInfoRespVoToJSON)),
    };
}

